// ============================================
// Elite Diam Store Front End Controller  (v2)
// LIVE version + backup features + fixes
//
// Tags used in this file:
//   [v2 FIX]   bug fix
//   [v2 PERF]  speed improvement (no behaviour change)
//   [v2 SAFE]  security / robustness
//   [ADDED] [FIX] [IMPROVED]  = tags from the previous version (kept)
//
// Debug: type  EliteDiam.debug = true  in the browser console to see
// variant / price logs.
// ============================================
(function () {
    "use strict";

    // Safe execution helper whether DOM is loading or already parsed
    function onDomReady(fn) {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", fn);
        } else {
            fn();
        }
    }

    // [v2 PERF] Only jQuery is required to start. Slick is handled separately
    // (see deferUntilSlick) so forms / FAQ / WhatsApp / price never wait for it
    // (before: everything waited up to 8s when Slick was late).
    function waitForDeps(callback) {
        var start = Date.now();
        var timeout = 8000;

        (function poll() {
            if (typeof window.jQuery !== "undefined") {
                callback(window.jQuery);
                return;
            }
            if (Date.now() - start >= timeout) {
                console.error("[EliteDiam] jQuery did not load within timeout.");
                return;
            }
            setTimeout(poll, 50);
        })();
    }

    waitForDeps(function ($) {
        // ------------------------------------------------------------
        // CONFIG: product-card-layout-02 on desktop (>=768px)
        //   true  -> 2-column image grid (slick removed)  [backup behaviour]
        //   false -> slider on desktop as well
        // ------------------------------------------------------------
        var DESKTOP_GRID_FOR_CARD_LAYOUT_02 = true;

        // ============================================================
        // [v2 PERF] Slick helpers - evaluated lazily, so a late-loading
        // Slick still initialises the sliders (before: if Slick was not
        // there at start, sliders were skipped for the whole page life).
        // ============================================================
        function slickReady() {
            return typeof $.fn.slick === "function";
        }

        var slickWaiters = [];
        var slickPolling = false;

        // ============================================================
        // [FIX 1] "Cannot read properties of undefined (reading 'slickGoTo')"
        // The theme (variants.js) calls .slick('slickGoTo', n) on a gallery
        // that is not a slider (e.g. desktop grid layout). Slick throws and
        // the rest of the theme's variant-change code is aborted (price,
        // availability, etc. never update). Method calls on elements that
        // are not initialised are now ignored instead of throwing.
        // ============================================================
        function installSlickGuard() {
            if (!slickReady() || $.fn.slick.__edSafe) return;
            var origSlick = $.fn.slick;
            var safeSlick = function (opt) {
                if (typeof opt === "string") {
                    var $ready = this.filter(function () { return !!this.slick; });
                    if (!$ready.length) return opt === "getSlick" ? undefined : this;
                    var ret = origSlick.apply($ready, arguments);
                    return ret === $ready ? this : ret;
                }
                return origSlick.apply(this, arguments);
            };
            $.extend(safeSlick, origSlick);
            safeSlick.__edSafe = true;
            $.fn.slick = safeSlick;
        }

        function deferUntilSlick(fn) {
            if (slickWaiters.indexOf(fn) === -1) slickWaiters.push(fn);
            if (slickPolling) return;
            slickPolling = true;
            var start = Date.now();
            (function poll() {
                if (slickReady()) {
                    installSlickGuard();
                    var queue = slickWaiters.splice(0);
                    queue.forEach(function (cb) {
                        try { cb(); } catch (err) { console.error("[EliteDiam]", err); }
                    });
                    return;
                }
                if (Date.now() - start >= 10000) {
                    console.warn("[EliteDiam] Slick did not load; sliders skipped.");
                    return;
                }
                setTimeout(poll, 100);
            })();
        }

        if (slickReady()) installSlickGuard();
        else deferUntilSlick(installSlickGuard);

        // ============================================================
        // [v2 PERF] ONE resize listener. Runs the jobs only when the WIDTH
        // really changed (mobile browsers fire "resize" on every scroll when
        // the address bar hides - that used to re-run slider code each time).
        // ============================================================
        var resizeJobs = [];
        var lastInnerWidth = window.innerWidth;
        var resizeTimer;
        function onWidthChange(fn) {
            resizeJobs.push(fn);
        }
        window.addEventListener(
            "resize",
            function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    if (window.innerWidth === lastInnerWidth) return;
                    lastInnerWidth = window.innerWidth;
                    resizeJobs.forEach(function (job) { job(); });
                }, 200);
            },
            { passive: true }
        );

        // [v2 SAFE] build message nodes with .text() - never inject server
        // text as HTML.
        function makeMsg(cls, text, style) {
            var $p = $("<p></p>").addClass(cls).text(text);
            if (style) $p.attr("style", style);
            return $p;
        }
        var ED_ERR_STYLE =
            "color:#c0392b; background:#fdf0ef; border:1px solid #e74c3c; padding:12px 16px; border-radius:8px; margin-bottom:16px; font-size:14px;";

        // ============================================================
        // [FIX 2] "Cannot read properties of null (reading 'classList')"
        // thrown inside the theme's setInputAvailability / updateVariantStatuses.
        // Main cause removed in initRingSizeDropdown (the <select> options
        // are no longer injected inside the theme's option fieldset).
        // As a safety net, those theme methods are wrapped so one bad
        // element can no longer abort the whole variant-change flow.
        // [v2] idempotent + runs again on DOM ready (to detect the real tag).
        // ============================================================
        function guardThemeVariantMethods() {
            if (!window.customElements || !customElements.whenDefined) return;

            function wrap(tag) {
                customElements.whenDefined(tag).then(function () {
                    var C = customElements.get(tag);
                    if (!C || !C.prototype) return;
                    ["setInputAvailability", "updateVariantStatuses"].forEach(function (m) {
                        var orig = C.prototype[m];
                        if (typeof orig !== "function" || orig.__edGuarded) return;
                        var wrapped = function () {
                            try {
                                return orig.apply(this, arguments);
                            } catch (err) {
                                console.warn("[EliteDiam] ignored theme error in " + m + ":", err && err.message);
                            }
                        };
                        wrapped.__edGuarded = true;
                        C.prototype[m] = wrapped;
                    });
                });
            }

            var tags = ["variant-selects", "variant-radios"];
            // also detect the real custom-element tag around the option fieldsets
            var fs = document.querySelector(".product-form__input");
            var el = fs && fs.parentElement;
            while (el && el.localName.indexOf("-") === -1) el = el.parentElement;
            if (el && tags.indexOf(el.localName) === -1) tags.push(el.localName);
            tags.forEach(wrap);
        }
        guardThemeVariantMethods();
        onDomReady(guardThemeVariantMethods);

        // ============================================
        // Review Read More / Read Less Toggle
        // ============================================
        // [v2 SAFE] text is inserted as text (not HTML)
        function renderReviewText($el, text, linkLabel, ellipsis) {
            $el.empty()
                .append(document.createTextNode(text + (ellipsis ? "... " : " ")))
                .append($('<span class="read-more-inline"></span>').text(linkLabel));
        }

        function initReadMore() {
            if ($(window).width() >= 768) {
                $(".review-text").each(function () {
                    if ($(this).attr("data-full")) return;

                    var fullText = $(this).text().trim();
                    var words = fullText.split(/\s+/);
                    var maxWords = 19;

                    if (words.length > maxWords) {
                        var shortText = words.slice(0, maxWords).join(" ");
                        renderReviewText($(this), shortText, "Read more", true);
                        $(this).attr("data-full", fullText);
                        $(this).attr("data-short", shortText);
                    }
                });
            }
        }

        $(document).on("click", ".read-more-inline", function (e) {
            if ($(window).width() < 768) return;

            e.preventDefault();
            e.stopPropagation();

            var parent = $(this).closest(".review-text");
            var fullText = parent.attr("data-full");
            var shortText = parent.attr("data-short");
            var expanding = $(this).text().includes("Read more");

            // [IMPROVED] Slick (infinite) keeps cloned cards. Apply the same
            // state to every card with the same review so the clone never
            // shows the old collapsed text.
            $(".review-text").filter(function () {
                return $(this).attr("data-full") === fullText;
            }).each(function () {
                var $t = $(this);
                if (expanding) renderReviewText($t, fullText, "Read less", false);
                else renderReviewText($t, shortText, "Read more", true);
                $t.css({ height: "auto", overflow: "visible" });
                $t.closest(".review-card").css({ height: "auto" });
            });

            setTimeout(function () {
                if ($(".reviews-wrapper").hasClass("slick-initialized")) {
                    $(".reviews-wrapper").slick("setPosition");
                }
            }, 100);
        });

        onWidthChange(initReadMore);

        // ============================================
        // Review Slider Initialization
        // ============================================
        function initReviewSlider() {
            var $slider = $(".review-slider");
            if (!$slider.length || $slider.hasClass("slick-initialized")) return;
            if (!slickReady()) { deferUntilSlick(initReviewSlider); return; }

            $slider.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: true,
                autoplay: false,
                autoplaySpeed: 4000,
                speed: 500,
                pauseOnHover: true,
                pauseOnFocus: true,
                responsive: [
                    { breakpoint: 1440, settings: { slidesToShow: 3 } },
                    { breakpoint: 1024, settings: { slidesToShow: 2, dots: true } },
                    { breakpoint: 768, settings: { slidesToShow: 1, adaptiveHeight: true, dots: true } }
                ]
            });

            $(".review-prev").off("click.reviewSlider").on("click.reviewSlider", function () {
                $slider.slick("slickPrev");
            });

            $(".review-next").off("click.reviewSlider").on("click.reviewSlider", function () {
                $slider.slick("slickNext");
            });
        }

        // ============================================
        // Why Elite Diam Slider Initialization
        // ============================================
        function equalizeWhyHeights() {
            var $items = $(".why-elite-diam .wrapper-content");
            if (!$items.length) return;
            var max = 0;
            $items.css("height", "auto"); // one write batch ...
            $items.each(function () {     // ... then reads only (single reflow)
                max = Math.max(max, $(this).outerHeight());
            });
            $items.height(max);
        }

        function initWhyEliteDiamSlider() {
            var $slider = $(".why-elite-diam .halo-row");
            if (!$slider.length || $slider.hasClass("slick-initialized")) return;
            if (!slickReady()) { deferUntilSlick(initWhyEliteDiamSlider); return; }

            // [v2 FIX] bind BEFORE .slick(): the old code bound after init, so the
            // "init" event was missed and heights were equalised only after the
            // first autoplay change (~2.5s later = visible layout jump).
            $slider.on("init afterChange setPosition", equalizeWhyHeights);

            $slider.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: true,
                speed: 500,
                autoplay: true,
                autoplaySpeed: 2500,
                responsive: [
                    { breakpoint: 1200, settings: { slidesToShow: 4, dots: true } },
                    { breakpoint: 992, settings: { slidesToShow: 3, dots: true } },
                    { breakpoint: 576, settings: { slidesToShow: 1, autoHeight: true, dots: true } }
                ]
            });

            // fonts can change text height after init
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalizeWhyHeights);

            // [v2 PERF] don't keep autoplaying (and re-measuring the layout)
            // while the section is off-screen
            if ("IntersectionObserver" in window) {
                new IntersectionObserver(function (entries) {
                    entries.forEach(function (en) {
                        $slider.slick(en.isIntersecting ? "slickPlay" : "slickPause");
                    });
                }).observe($slider[0]);
            }
        }

        // ============================================
        // Hero Banner Slider Initialization
        // ============================================
        function initHeroBannerSlider() {
            var $slider = $(".ed-hero-banner-slider");
            if (!$slider.length || $slider.hasClass("slick-initialized")) return;
            if (!slickReady()) { deferUntilSlick(initHeroBannerSlider); return; }
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                autoplay: false,
                // autoplaySpeed: 3000,
                infinite: true,
                adaptiveHeight: false
            });
        }

        // ============================================
        // Mobile Rich Text Truncation
        // ============================================
        function initRichTextReadMore() {
            if (window.innerWidth <= 768) {
                $(".about-heading .rich-text__text, .our-responsibility .rich-text__text").each(function () {
                    const $el = $(this);
                    if ($el.find(".rich-text__read-more").length) return;

                    const words = $el.text().trim().split(/\s+/);
                    if (words.length <= 20) return;

                    const short = words.slice(0, 20).join(" ");
                    const full = $el.html();

                    // [v2 SAFE] "short" is plain text -> inserted with .text()
                    $el.empty()
                        .append($('<span class="short"></span>').text(short + "... "))
                        .append($('<span class="full" style="display:none;"></span>').html(full))
                        .append('<button class="rich-text__read-more" type="button"> Read more</button>');

                    $el.find("button").on("click", function () {
                        const $btn = $(this);
                        $el.find(".short").toggle();
                        $el.find(".full").slideToggle(500);
                        $btn.text($btn.text().includes("more") ? " Read less" : " Read more");
                    });
                });
            }
        }

        // ============================================
        // Product Page Gallery & Dynamic Tabs
        // ============================================
        function initProductViewTabs($) {
            $("body.template-product .tabs-contents.tabs-contents-vertical .tab-content").removeClass("is-active");
            $("body.template-product .tabs-contents.tabs-contents-vertical .toggle-content").removeClass("is-active");
            $("body.template-product .tabs-contents.tabs-contents-vertical .toggleLink").removeClass("is-open");
            $(".productView-tab .tabs-contents-vertical .tab-content:first-child .toggle-content:not(.show-mobile)").css("display", "block");

            var firstTab = $("body.template-product .tab-content").first();
            firstTab.addClass("is-active");
            firstTab.find(".toggleLink").addClass("is-open");
            firstTab.find(".toggle-content").addClass("is-active");

            // [FIX] Sliders now follow the backup's layout-aware logic
            handleProductSliderResize();
            initProductVideo();

            initColorFilterState();
        }

        // ============================================================
        // [FIX] Product gallery sliders (layout aware, from backup)
        //  - halo layout-1            -> slick on all screens
        //  - product-card-layout-02   -> slick only on mobile (<=767px),
        //                                 desktop = unslick
        //  - any other page           -> same as live (init everywhere)
        // ============================================================
        function initProductSliders($container) {
            if (!slickReady()) { deferUntilSlick(handleProductSliderResize); return; }
            var $navSlider = $container.find(".productView-nav");
            var $forSlider = $container.find(".productView-for");

            if ($navSlider.length && !$navSlider.hasClass("slick-initialized")) {
                $navSlider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    infinite: true,
                    fade: true,
                    speed: 0,
                    adaptiveHeight: true,
                    asNavFor: $forSlider
                });
            }

            if ($forSlider.length && !$forSlider.hasClass("slick-initialized")) {
                $forSlider.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    infinite: true,
                    vertical: true,
                    verticalSwiping: false,
                    focusOnSelect: true,
                    asNavFor: $navSlider,
                    prevArrow:
                        '<button type="button" class="slick-prev">' +
                        '<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '<path d="M7.72845 0.602382L6.57903 -0.54595L0.318446 5.71247C0.217528 5.81275 0.137439 5.932 0.0827872 6.06335C0.0281353 6.19471 -3.13381e-07 6.33557 -3.07162e-07 6.47784C-3.00943e-07 6.62011 0.0281353 6.76098 0.0827872 6.89233C0.137439 7.02368 0.217528 7.14293 0.318446 7.24322L6.57903 13.5049 7.72736 12.3565 1.85136 6.47947 7.72845 0.602382Z" fill="#593476"/>' +
                        "</svg>" +
                        "</button>",
                    nextArrow:
                        '<button type="button" class="slick-next">' +
                        '<svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '<path d="M-0.00188387 1.14828L1.14753 -5.18548e-05L7.40812 6.25836C7.50903 6.35865 7.58912 6.4779 7.64377 6.60925C7.69843 6.7406 7.72656 6.88147 7.72656 7.02374C7.72656 7.16601 7.69843 7.30687 7.64377 7.43823C7.58912 7.56958 7.50903 7.68883 7.40812 7.78911L1.14753 14.0508 -0.000800615 12.9024 5.8752 7.02536 -0.00188387 1.14828Z" fill="#593476"/>' +
                        "</svg>" +
                        "</button>",
                    responsive: [
                        { breakpoint: 1281, settings: { vertical: false, verticalSwiping: false, slidesToShow: 4 } },
                        { breakpoint: 480, settings: { slidesToShow: 3, vertical: false, verticalSwiping: false } }
                    ]
                });
            }
        }

        function handleProductSliderResize() {
            // [v2 PERF] nothing to do on pages without a product gallery
            if (!document.querySelector(".productView-nav, .productView-for")) return;

            var width = window.innerWidth;
            var $halo = $(".productView.halo-productView.layout-1");
            var $card = $(".body-custom-width.product-card-layout-02");

            if ($halo.length) initProductSliders($halo);

            if ($card.length) {
                if (width <= 767 || !DESKTOP_GRID_FOR_CARD_LAYOUT_02) {
                    initProductSliders($card);
                } else if (slickReady()) {
                    $card.find(".productView-nav.slick-initialized").slick("unslick");
                    $card.find(".productView-for.slick-initialized").slick("unslick");
                }
            }

            // Neither layout wrapper found -> behave like the live file did
            if (!$halo.length && !$card.length) initProductSliders($(document));
        }

        function initProductVideo() {
            var $navSlider = $(".productView-nav");
            if (!$navSlider.length) return;

            $navSlider.off("afterChange.productVideo").on("afterChange.productVideo", function (event, slick, currentSlide) {
                $(".productView-video video").each(function () {
                    this.pause();
                    this.currentTime = 0;
                });
                var video = $(slick.$slides[currentSlide]).find("video").get(0);
                if (!video) return;
                video.muted = false;
                video.play().catch(function () {});
            });
        }

        onWidthChange(handleProductSliderResize);

        // ============================================================
        // [FIX] Color facet active state - DELEGATED (survives AJAX
        // filter re-render) + re-run from the shared observer
        // ============================================================
        function initColorFilterState() {
            $('.Color .facets__item input[type="checkbox"]').each(function () {
                $(this).closest(".facets__label").toggleClass("active", this.checked);
            });
        }
        $(document).on("change", '.Color .facets__item input[type="checkbox"]', function () {
            $(this).closest(".facets__label").toggleClass("active", this.checked);
        });
        window.__edInitColorFilterState = initColorFilterState;

        // ============================================================
        // [FIX] Hide product meta for ring / bracelet / necklace / earring
        // ============================================================
        // [v2 FIX] whole-word match. Before, title.includes("ring") also hid the
        // meta of e.g. "Herringbone Chain" / "Spring ..." products.
        var EXCLUDED_META_TYPES = /\b(?:rings?|bracelets?|necklaces?|earrings?)\b/;
        function hideProductMeta() {
            // [IMPROVED] only on the product page (collection headings such as
            // "Engagement Rings" must not hide meta of product cards)
            if (!document.body.classList.contains("template-product")) return;
            var titleElement = document.querySelector("h1.productView-title, h1.product__title, .productView-title, h1");
            if (!titleElement) return;
            var title = titleElement.textContent.trim().toLowerCase();
            if (EXCLUDED_META_TYPES.test(title)) {
                document.querySelectorAll(".product-meta-list").forEach(function (el) {
                    el.style.display = "none";
                });
            }
        }

        // ============================================================
        // [FIX] Gallery jump to variant image (from backup)
        // ============================================================
        function updateGalleryForVariant(variantId) {
            if (!variantId || !window.productVariantImages) return;
            var imageId = window.productVariantImages[variantId];
            var $gallery = $(".productView-nav");
            if (!imageId || !$gallery.length || !$gallery.hasClass("slick-initialized")) return;

            var slideIndex = -1;
            $gallery.find(".slick-slide").each(function () {
                if ($(this).attr("data-media-id") == imageId) {
                    slideIndex = $(this).data("slick-index");
                    return false;
                }
            });
            if (slideIndex !== -1) $gallery.slick("slickGoTo", slideIndex);
        }

        // ============================================================
        // [FIX] Newsletter popup close - with double-bind guard
        // ============================================================
        function initNewsletterPopup() {
            var popup = document.getElementById("newsletter-success-modal");
            if (!popup) return;
            var closeButton = popup.querySelector(".close-modal");
            if (!closeButton || closeButton.dataset.bound === "true") return;
            closeButton.dataset.bound = "true";
            closeButton.addEventListener("click", function () {
                popup.style.display = "none";
                document.body.classList.remove("open-newsletter-popup");
            });
        }
        window.__edInitNewsletterPopup = initNewsletterPopup;
        window.__edInitFaq = initFaqHandlers;

        // Public globals (same as backup)
        window.EliteDiam = window.EliteDiam || {};
        window.EliteDiam.showVariantImage = showVariantImage;
        window.EliteDiam.updateGalleryForVariant = updateGalleryForVariant;

        // ============================================
        // Forms Submission Handlers (Zoho Integrations)
        // ============================================
        $(document).ready(function ($) {
            initProductViewTabs($);
            // General Contact Form
            $(document).on("submit", ".contact-form:not(#diamondForm, #wholesaleForm, #lab-grown-diamond-wholesaler, #lab-grown-diamond-manufacturer, #lab-grown-diamond-dealer, #lab-grown-diamond-merchant)", function (e) {
                e.preventDefault();
                const form = $(this);
                const formData = new FormData(this);
                const submitBtn = form.find('[type="submit"]');
                const btnOrigText = submitBtn.text();

                $(".t4s-form-message").remove();
                submitBtn.prop("disabled", true).text("Sending...");

                $.ajax({
                    url: "https://ourportfolios.co/shopify-webhook/elitediam/zoho/zoho-contact.php",
                    type: "POST",
                    data: formData,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    timeout: 20000,
                    success: function (res) {
                        if (res && res.status === true) {
                            form[0].reset();
                            form.before(makeMsg("t4s-form-message t4s-form-message--success", "Thanks for contacting us. We'll get back to you as soon as possible."));
                        } else {
                            const msg = res && res.message ? res.message : "Something went wrong. Please try again.";
                            form.before(makeMsg("t4s-form-message t4s-form-message--error", msg));
                        }
                    },
                    error: function (xhr, status) {
                        const msg = status === "timeout" ? "Request timed out. Please try again." : "Something went wrong. Please try again later.";
                        form.before(makeMsg("t4s-form-message t4s-form-message--error", msg));
                    },
                    complete: function () {
                        submitBtn.prop("disabled", false).text(btnOrigText);
                        setTimeout(function () {
                            $(".t4s-form-message").fadeOut(400, function () { $(this).remove(); });
                        }, 6000);
                    }
                });
            });
            // Consolidated Wholesale & Manufacturer Form Handlers
            const WHOLESALE_TYPE_FORMS = {
                "#wholesaleForm": "https://ourportfolios.co/shopify-webhook/elitediam/zoho/zoho-wholesale.php",
                "#lab-grown-diamond-wholesaler": "https://ourportfolios.co/shopify-webhook/elitediam/zoho/zoho-labgrown-diamond-wholesaler.php",
                "#lab-grown-diamond-manufacturer": "https://ourportfolios.co/shopify-webhook/elitediam/zoho/zoho-labgrown-diamond-manufacturer.php",
                "#lab-grown-diamond-dealer": "https://ourportfolios.co/shopify-webhook/elitediam/zoho/lab-grown-diamonds-dealer.php",
                "#lab-grown-diamond-merchant": "https://ourportfolios.co/shopify-webhook/elitediam/zoho/lab-grown-diamonds-merchant.php"
            };
            $(document).on("submit", Object.keys(WHOLESALE_TYPE_FORMS).join(", "), function (e) {
                e.preventDefault();
                var form = $(this);
                var endpoint = WHOLESALE_TYPE_FORMS[
                    Object.keys(WHOLESALE_TYPE_FORMS).find(function (sel) { return form.is(sel); })
                ];
                var formData = new FormData(this);
                var submitBtn = form.find('[type="submit"]');
                var btnOrigText = submitBtn.text();
                var msgBox = $("#wholesaleFormMessage");
                msgBox.removeClass("t4s-form-message--success t4s-form-message--error").empty();
                submitBtn.prop("disabled", true).text("Sending...");
                $.ajax({
                    url: endpoint,
                    type: "POST",
                    data: formData,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    timeout: 20000,
                    success: function (res) {
                        if (res && res.status === true) {
                            form[0].reset();
                            msgBox.addClass("t4s-form-message t4s-form-message--success").text(res.message || "Thank you! We will contact you soon.").show();
                        } else {
                            var msg = res && res.message ? res.message : "Something went wrong. Please try again.";
                            msgBox.addClass("t4s-form-message t4s-form-message--error").text(msg).show();
                        }
                    },
                    error: function (xhr, status) {
                        var msg = status === "timeout" ? "Request timed out. Please try again." : "Something went wrong. Please try again later.";
                        msgBox.addClass("t4s-form-message t4s-form-message--error").text(msg).show();
                    },
                    complete: function () {
                        submitBtn.prop("disabled", false).text(btnOrigText);
                        setTimeout(function () {
                            msgBox.fadeOut(400, function () {
                                $(this).empty().removeClass("t4s-form-message--success t4s-form-message--error");
                            });
                        }, 6000);
                    }
                });
            });
            // Newsletter AJAX Submission
            $(document).on("submit", "#ContactFooter", function (e) {
                e.preventDefault();
                const form = $(this);
                const formData = new FormData(this);
                const submitBtn = form.find('[type="submit"]');
                const btnOrigText = submitBtn.text();

                form.find(".newsletter-ajax-msg").remove();
                submitBtn.prop("disabled", true).text("Please wait...");

                function showNewsletterMsg(text, color) {
                    form.find(".newsletter-form__field-wrapper").after(
                        makeMsg("newsletter-ajax-msg", text, "color: " + color + "; font-size: 13px; margin-top: 8px; text-align: center;")
                    );
                }

                $.ajax({
                    url: "https://ourportfolios.co/shopify-webhook/elitediam/zoho/zoho-newsletter.php",
                    type: "POST",
                    data: formData,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    timeout: 20000,
                    success: function (res) {
                        const isSuccess = res && res.status === true;
                        const msg = isSuccess ? "✓ Thank you for subscribing!" : ("✕ " + (res && res.message ? res.message : "Something went wrong. Please try again."));
                        if (isSuccess) form[0].reset();
                        showNewsletterMsg(msg, isSuccess ? "#27ae60" : "#c0392b");
                    },
                    error: function (xhr, status) {
                        const msg = status === "timeout" ? "Request timed out. Please try again." : "Something went wrong. Please try again later.";
                        showNewsletterMsg("✕ " + msg, "#c0392b");
                    },
                    complete: function () {
                        submitBtn.prop("disabled", false).text(btnOrigText);
                        setTimeout(function () {
                            form.find(".newsletter-ajax-msg").fadeOut(400, function () { $(this).remove(); });
                        }, 6000);
                    }
                });
            });
            // Hand Visualizer Tool Form
            $(document).on("submit", "#edFormCard", function (e) {
                e.preventDefault();
                const form = $(this);
                const formData = new FormData(this);
                const submitBtn = form.find('[type="submit"]');
                const btnOrigText = submitBtn.text();
                const successCard = $("#edSuccessCard");
                $(".ed-form-error").remove();
                const countryCode = form.find('[name="contact[country_code]"]').val();
                const rawPhone = form.find('[name="contact[phone_raw]"]').val();
                formData.set("contact[phone]", countryCode + " " + rawPhone);
                submitBtn.prop("disabled", true).text("Sending...");
                $.ajax({
                    url: "https://ourportfolios.co/shopify-webhook/elitediam/zoho/submit-hand-visualizer.php",
                    type: "POST",
                    data: formData,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    timeout: 20000,
                    success: function (res) {
                        if (res && res.status === true) {
                            const caratVal = form.find('[name="contact[carat]"]').val();
                            const shapeVal = form.find('[name="contact[shape]"]').val();
                            const ringSizeVal = form.find('[name="contact[ring_size]"]').val();
                            $("#edSuccessSummary").text(`${caratVal}ct ${shapeVal}, ${ringSizeVal}`);

                            form.hide();
                            successCard.addClass("active");
                            form[0].reset();
                        } else {
                            const msg = res && res.message ? res.message : "Something went wrong. Please try again.";
                            form.before(makeMsg("ed-form-error", msg, ED_ERR_STYLE));
                        }
                    },
                    error: function (xhr, status) {
                        const msg = status === "timeout" ? "Request timed out. Please check your connection and try again." : "Something went wrong. Please try again later.";
                        form.before(makeMsg("ed-form-error", msg, ED_ERR_STYLE));
                    },
                    complete: function () {
                        submitBtn.prop("disabled", false).text(btnOrigText);
                    }
                });
            });
            $(document).on("click", "#eliteDiamModal .ed-success-action-btn:not(.whatsapp)", function () {
                $(".ed-form-error").remove();
                $("#edSuccessCard").removeClass("active");
                $("#edFormCard").show();
            });
            $(document).on("click", "#edWhatsappBtn", function () {
                const carat = $("#edHiddenCarat").val();
                const shape = $("#edHiddenShape").val();
                const ring = $("#edHiddenRingSize").val();
                const text = `Hello Elite Diam! I have simulated a design using your Size Visualizer:\n- Shape: ${shape}\n- Carat Weight: ${carat} ct\n- Ring Size: ${ring}`;
                window.open("https://wa.me/919023351659?text=" + encodeURIComponent(text), "_blank", "noopener");
            });
        });

        // ============================================
        // HOME PAGE SPEED: Lazy-init below-the-fold sliders
        // ============================================
        function whenVisible(selector, callback, rootMargin) {
            var el = document.querySelector(selector);
            if (!el) return; // section not on this page — nothing to do

            if (!("IntersectionObserver" in window)) {
                callback();
                return;
            }
            var io = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            callback();
                            io.unobserve(entry.target);
                            io.disconnect();
                        }
                    });
                },
                { rootMargin: rootMargin || "300px 0px" }
            );
            io.observe(el);
        }

        // ============================================================
        // [ADDED] FAQ handlers with DOUBLE-BIND GUARD (data-bound)
        // Safe to call multiple times (section load etc.) — each
        // element is bound only once.
        // ============================================================
        // Runs cb once when `prop` finishes transitioning on el. A newer call on the
        // same element cancels the older one (fast clicks no longer fire stale
        // callbacks), and a timer fallback guarantees cb runs even if the browser
        // never fires transitionend (e.g. height did not actually change).
        function afterTransition(el, prop, cb) {
            var token = (el.__edTok = (el.__edTok || 0) + 1);
            var finished = false;
            var timer;

            function finish() {
                if (finished) return;
                finished = true;
                clearTimeout(timer);
                el.removeEventListener("transitionend", onEnd);
                if (el.__edTok === token) cb();
            }
            function onEnd(e) {
                if (e.target === el && e.propertyName === prop) finish();
            }

            var cs = window.getComputedStyle(el);
            var dur = (parseFloat(cs.transitionDuration) || 0) * 1000;
            var delay = (parseFloat(cs.transitionDelay) || 0) * 1000;

            el.addEventListener("transitionend", onEnd);
            timer = setTimeout(finish, dur + delay + 120);
        }

        function closeFaqItem(item, content) {
            content.style.height = content.scrollHeight + "px";
            requestAnimationFrame(function () { content.style.height = "0px"; });
            afterTransition(content, "height", function () { item.open = false; });
        }

        function openFaqItem(item, content) {
            item.open = true;
            content.style.height = "0px";
            requestAnimationFrame(function () { content.style.height = content.scrollHeight + "px"; });
            afterTransition(content, "height", function () { content.style.height = "auto"; });
        }

        function initFaqHandlers() {
            document.querySelectorAll(".diamond-faq .faq-item").forEach((item) => {
                const summary = item.querySelector("summary");
                const content = item.querySelector(".faq-answer");
                if (!summary || !content) return;
                if (summary.dataset.bound === "true") return; // guard
                summary.dataset.bound = "true";

                content.style.height = item.open ? "auto" : "0px";

                summary.addEventListener("click", function (e) {
                    e.preventDefault();

                    if (item.open) {
                        closeFaqItem(item, content);
                    } else {
                        document.querySelectorAll(".diamond-faq .faq-item[open]").forEach((openItem) => {
                            if (openItem === item) return;
                            const openContent = openItem.querySelector(".faq-answer");
                            if (openContent) closeFaqItem(openItem, openContent);
                        });
                        openFaqItem(item, content);
                    }
                });
            });

            document.querySelectorAll(".faq-question").forEach((button) => {
                if (button.closest("details")) return; // handled by the <summary> logic above (no double toggle)
                if (button.dataset.bound === "true") return; // guard
                button.dataset.bound = "true";

                button.addEventListener("click", function () {
                    const item = this.parentElement;
                    const answer = item.querySelector(".faq-answer");
                    if (!answer) return;
                    if (item.classList.contains("active")) {
                        answer.style.maxHeight = answer.scrollHeight + "px";
                        requestAnimationFrame(() => { answer.style.maxHeight = "0"; });
                        item.classList.remove("active");
                        afterTransition(answer, "max-height", function () {}); // cancels a pending "open" callback
                    } else {
                        item.classList.add("active");
                        answer.style.maxHeight = answer.scrollHeight + "px";
                        afterTransition(answer, "max-height", function () {
                            if (item.classList.contains("active")) answer.style.maxHeight = "none";
                        });
                    }
                });
            });
        }

        // ============================================================
        // [ADDED] Ring Size Dropdown (radio -> select)
        // [v2 FIX] Works even when the theme re-renders the radios:
        //   * the options + hidden labels are re-synced with the CURRENT radios
        //     (before: an old <select> stayed bound to a removed fieldset and the
        //     new radio labels became visible again)
        //   * the change handler is delegated and always uses the CURRENT fieldset
        //   * <option> elements are created with the DOM API (no HTML injection)
        // ============================================================
        function initRingSizeDropdown() {
            $(".product-form__input").each(function () {
                const fieldset = this;

                const radios = Array.prototype.slice.call(fieldset.querySelectorAll('input[name="Ring size"]'));
                if (!radios.length) return;

                // [FIX 2] clean up a dropdown created inside the fieldset by the previous version
                const legacy = fieldset.querySelector(".ring-size-dropdown");
                if (legacy) legacy.remove();

                // existing dropdown = sibling AFTER the fieldset
                const next = fieldset.nextElementSibling;
                let select = next && next.classList && next.classList.contains("ring-size-dropdown") ? next : null;
                const isNew = !select;
                if (isNew) {
                    select = document.createElement("select");
                    select.className = "ring-size-dropdown";
                }

                // hide the radio labels (also for radios that were just re-rendered)
                radios.forEach(function (radio) {
                    const label = radio.nextElementSibling;
                    if (label && label.style.display !== "none") label.style.display = "none";
                });

                // (re)build the options only when they differ from the radios
                const wanted = radios.map(function (r) { return r.value; }).join("\u0001");
                const have = Array.prototype.slice.call(select.options, 1).map(function (o) { return o.value; }).join("\u0001");
                if (isNew || wanted !== have || !select.options.length) {
                    select.textContent = "";
                    const placeholder = new Option("Select Ring Size", "");
                    placeholder.disabled = true;
                    select.appendChild(placeholder);
                    radios.forEach(function (radio) {
                        select.appendChild(new Option(radio.value, radio.value));
                    });
                }

                // keep the dropdown in sync with the currently checked radio
                const checked = fieldset.querySelector('input[name="Ring size"]:checked');
                if (checked) {
                    select.value = checked.value;
                } else {
                    select.selectedIndex = 0;
                }

                // [FIX 2] placed OUTSIDE the theme's fieldset so the theme's own
                // variant scripts (which scan "input[type=radio], option" inside
                // .product-form__input) never see these <option> elements.
                if (isNew) fieldset.insertAdjacentElement("afterend", select);
            });
        }
        // [v2 FIX] delegated: select -> radio (uses the fieldset right before the select)
        $(document).on("change", "select.ring-size-dropdown", function () {
            const fieldset = this.previousElementSibling;
            if (!fieldset || !fieldset.querySelector) return;
            const radio = fieldset.querySelector('input[name="Ring size"][value="' + CSS.escape(this.value) + '"]');
            if (radio) radio.click();
        });
        // keep dropdown in sync when the radio changes (theme / URL / other code)
        $(document).on("change", 'input[name="Ring size"]', function () {
            const fs = this.closest(".product-form__input");
            const sel = fs && fs.nextElementSibling;
            if (sel && sel.classList && sel.classList.contains("ring-size-dropdown")) sel.value = this.value;
        });
        // Expose for the shared observer (outside this closure)
        window.__edInitRingSize = initRingSizeDropdown;

        // ============================================================
        // [ADDED] Color Variant Image Switch
        //
        // [FIX 4] "Rose -> Gold needs 2 clicks"
        // Cause: the image order was applied once, immediately on `change`.
        // The theme's own variant code (it re-renders / re-orders the gallery a
        // moment later) then overwrote it. The 2nd click works only because the
        // radio is already selected, so no theme update runs. Now:
        //   * the apply step is idempotent (does nothing if already correct),
        //   * triggers are debounced into ONE run (change + label click),
        //   * a lightweight watcher re-applies it if the theme changes the gallery
        //     afterwards (only active on pages that have a product gallery),
        //   * it always reads the CURRENTLY checked colour (never a stale radio).
        // ============================================================
        var colorState = { radio: null, timer: null, timer2: null, observer: null, busy: false };
        var GALLERY_SEL = ".productView-nav, .productView-image";

        function dlog() {
            if (window.EliteDiam && window.EliteDiam.debug) {
                console.log.apply(console, ["[EliteDiam]"].concat([].slice.call(arguments)));
            }
        }

        function currentColorRadio() {
            var checked = document.querySelector('input[name="Color"]:checked');
            if (checked) return checked;
            return colorState.radio && document.contains(colorState.radio) ? colorState.radio : null;
        }

        function makeColorMatcher(color) {
            var normalizedColor = color.replace(/[_\s]+/g, "-");
            return function isColorMatch(slide) {
                var $img = $(slide).find("img").first();
                var alt = ($img.attr("alt") || "").trim().toLowerCase();
                var src = ($img.attr("src") || $img.attr("data-src") || $img.attr("srcset") || "").toLowerCase();

                if (alt === color || alt === normalizedColor) return true;

                var filename = src.split("?")[0].split("/").pop() || "";
                filename = filename
                    .replace(/\.(png|jpg|jpeg|webp|avif)$/i, "")
                    .toLowerCase()
                    .replace(/[_\s]+/g, "-");

                /* Rose Gold */
                if (color === "rose gold" || color === "rosegold" || normalizedColor === "rose-gold") {
                    return filename.includes("rose-gold") || filename.includes("rosegold");
                }
                /* Gold */
                if (color === "gold") {
                    if (filename.includes("rose-gold") || filename.includes("rosegold")) return false;
                    return /(^|-)gold(-|$)/.test(filename);
                }
                /* Silver */
                if (color === "silver") return filename.includes("silver");

                return filename.includes(normalizedColor);
            };
        }

        function applyVariantImage() {
            var radio = currentColorRadio();
            if (!radio) return;

            var color = (radio.value || "").trim().toLowerCase();
            var $gallery = $(".productView-nav").first();
            if (!color || !$gallery.length) return;

            var $slides = $gallery.find(".productView-image").not(".slick-cloned");
            if (!$slides.length) return;

            var isColorMatch = makeColorMatcher(color);
            var isSlick = $gallery.hasClass("slick-initialized");

            colorState.busy = true;
            try {
                /* DESKTOP */
                if (window.innerWidth >= 768) {
                    var matchEls = $slides.filter(function () { return isColorMatch(this); }).toArray();

                    if (!matchEls.length) {
                        dlog("No image found for color:", color);
                        return;
                    }

                    // Already first, in order -> nothing to do (idempotent)
                    var alreadyFirst = matchEls.every(function (el, i) { return $slides.get(i) === el; });

                    if (alreadyFirst) {
                        if (isSlick) {
                            var cur = $gallery.slick("slickCurrentSlide");
                            if (cur !== 0) $gallery.slick("slickGoTo", 0, true);
                        }
                        return;
                    }

                    if (isSlick) {
                        var slick = $gallery.slick("getSlick");
                        var settings = slick && slick.options ? $.extend(true, {}, slick.options) : {};

                        $gallery.slick("unslick");
                        for (var i = matchEls.length - 1; i >= 0; i--) $gallery.prepend(matchEls[i]);

                        settings.initialSlide = 0;
                        $gallery.slick(settings);
                        $gallery.slick("slickGoTo", 0, true);
                    } else {
                        for (var j = matchEls.length - 1; j >= 0; j--) $gallery.prepend(matchEls[j]);
                    }
                    return;
                }

                /* MOBILE */
                var matchIndex = -1;
                $slides.each(function (index) {
                    if (isColorMatch(this)) {
                        matchIndex = index;
                        return false;
                    }
                });
                if (matchIndex === -1) return;

                if (isSlick) {
                    if ($gallery.slick("slickCurrentSlide") !== matchIndex) {
                        $gallery.slick("slickGoTo", matchIndex, true);
                    }
                } else {
                    var $target = $slides.eq(matchIndex);
                    if (!$target.hasClass("is-active")) {
                        $slides.removeClass("is-active");
                        $target.addClass("is-active");
                        if ($target[0]) {
                            $target[0].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
                        }
                    }
                }
            } finally {
                requestAnimationFrame(function () { colorState.busy = false; });
            }
        }

        function scheduleColorApply(delay) {
            clearTimeout(colorState.timer);
            colorState.timer = setTimeout(applyVariantImage, delay);
        }

        function galleryNodeChanged(n) {
            if (!n || n.nodeType !== 1) return false;
            return (
                (n.matches && n.matches(GALLERY_SEL)) ||
                (n.closest && n.closest(GALLERY_SEL)) ||
                (n.querySelector && n.querySelector(GALLERY_SEL))
            );
        }

        function startGalleryWatcher() {
            if (colorState.observer || !window.MutationObserver) return;
            if (!document.querySelector(".productView-nav")) return;

            var root = document.getElementById("MainContent") || document.querySelector("main") || document.body;
            colorState.observer = new MutationObserver(function (mutations) {
                if (colorState.busy) return;
                for (var i = 0; i < mutations.length; i++) {
                    var m = mutations[i];
                    if (m.type !== "childList") continue;
                    var hit = galleryNodeChanged(m.target);
                    for (var a = 0; !hit && a < m.addedNodes.length; a++) hit = galleryNodeChanged(m.addedNodes[a]);
                    for (var r = 0; !hit && r < m.removedNodes.length; r++) hit = galleryNodeChanged(m.removedNodes[r]);
                    if (hit) {
                        scheduleColorApply(80);
                        return;
                    }
                }
            });
            colorState.observer.observe(root, { childList: true, subtree: true });
        }

        // Public: kept for backward compatibility (window.EliteDiam.showVariantImage)
        function showVariantImage(radio) {
            if (!radio) return;
            colorState.radio = radio;
            startGalleryWatcher();
            scheduleColorApply(30);                       // after the click has been applied
            clearTimeout(colorState.timer2);
            colorState.timer2 = setTimeout(applyVariantImage, 600); // after the theme's own async update
        }

        $(document).on("change", 'input[name="Color"]', function () {
            showVariantImage(this);
        });

        // Clicking the swatch that is ALREADY selected does not fire `change`,
        // so the click itself must also re-apply the images.
        $(document).on("click", "label[for]", function () {
            var radio = document.getElementById($(this).attr("for"));
            if (!radio || radio.name !== "Color") return;
            showVariantImage(radio);
        });

        function initSelectedColor() {
            if (!document.body.classList.contains("template-product")) return;
            var run = function () {
                var selectedRadio = document.querySelector('input[name="Color"]:checked');
                if (selectedRadio) showVariantImage(selectedRadio);
            };
            if ("requestIdleCallback" in window) window.requestIdleCallback(run, { timeout: 1200 });
            else setTimeout(run, 300);
        }

        // ============================================================
        // [ADDED] Variant Price Update
        // ============================================================
        // [FIX 3] Price did not change when the colour changed (Gold = €2,000 in Shopify
        // but page still showed Silver's €1.920). The variant is found from ALL option
        // fieldsets (in order), numbers like "2.5" / "2.50" are treated as equal, and
        // the price format follows the store (e.g. €1.920 vs €1,920).
        //
        // [v2 FIX] "price shows the OLD value, then the new one appears"
        // Cause: the price is written by TWO scripts. This file writes the new price
        // immediately, then the theme's own AJAX variant update (variants.js ->
        // fetch -> replaces the price block) writes it again a moment later. When the
        // theme's write is late / stale / formatted differently, the visitor sees the
        // old value flash. Now:
        //   * the price is computed from the selected variant ONCE (price model),
        //   * it is written only when the text really differs (no needless DOM work),
        //   * for 4s after every change a MutationObserver watches the price block and
        //     restores the correct price in the same microtask (= before the browser
        //     paints), so a late theme update can never show the old price,
        //   * in the console a warning appears if the variant shown here differs from
        //     the variant the theme will add to the cart (that would be a theme bug).
        function sameOption(a, b) {
            if (a == null || b == null) return false;
            a = String(a).trim().toLowerCase();
            b = String(b).trim().toLowerCase();
            if (a === b) return true;
            var na = parseFloat(a), nb = parseFloat(b);
            return !isNaN(na) && !isNaN(nb) && na === nb && /^[\d.,\s]+$/.test(a) && /^[\d.,\s]+$/.test(b);
        }

        var variantsCache = { node: null, text: "", data: null };
        function getVariantsJson() {
            var nodes = document.querySelectorAll(
                '.productView-options script[type="application/json"], variant-selects script[type="application/json"], variant-radios script[type="application/json"]'
            );
            for (var i = 0; i < nodes.length; i++) {
                var node = nodes[i];
                var text = node.textContent;
                if (variantsCache.node === node && variantsCache.text === text) return variantsCache.data;
                try {
                    var data = JSON.parse(text);
                    // [v2 FIX] take the first block that really is a variants array
                    if (Array.isArray(data) && data.length && data[0] && typeof data[0].price !== "undefined") {
                        variantsCache = { node: node, text: text, data: data };
                        return data;
                    }
                } catch (error) {
                    console.error("Unable to parse product variants:", error);
                }
            }
            return null;
        }

        function getSelectedOptionValues(box) {
            var values = [];
            box.querySelectorAll("fieldset.product-form__input, .product-form__input").forEach(function (group) {
                if (group.matches(".product-form__input .product-form__input")) return; // nested duplicate
                if (!group.querySelector('input[type="radio"]')) return; // not an option group
                var checked = group.querySelector('input[type="radio"]:checked');
                values.push(checked ? checked.value : null);
            });
            return values;
        }

        var priceLocale = null;
        function detectPriceLocale() {
            var mf = (window.Shopify && window.Shopify.money_format) || "";
            if (/with_comma_separator/.test(mf)) return "de-DE";
            var txt = $(".price-item--sale, .price-item--regular").first().text() || "";
            if (/\d\.\d{3}(?!\d)/.test(txt)) return "de-DE";
            if (/\d,\d{3}(?!\d)/.test(txt)) return "en-US";
            return null; // cannot tell yet -> do not cache a guess
        }
        function formatPrice(value) {
            // [v2 FIX] cache only a real detection (before: a first price without a
            // thousands separator cached "en-US" forever)
            if (!priceLocale) priceLocale = detectPriceLocale();
            var mf = (window.Shopify && window.Shopify.money_format) || "";
            // [v2 FIX] keep cents when the price has cents (before: always rounded)
            var decimals = /no_decimals/.test(mf) ? 0 : value % 1 ? 2 : 0;
            return value.toLocaleString(priceLocale || "en-US", {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            });
        }

        function buildPriceModel(variant) {
            const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
            const symbols = {
                EUR: "€", USD: "$", GBP: "£", INR: "Rs. ", AUD: "$", CAD: "$",
                NZD: "$", MXN: "$", PHP: "₱", IDR: "Rp", AED: "د.إ"
            };
            const symbol = symbols[currency] || currency + " ";
            const price = variant.price / 100;
            const compare = (variant.compare_at_price || 0) / 100;
            const hasDiscount = compare > price;
            const save = hasDiscount ? compare - price : 0;
            const percent = hasDiscount ? Math.round((save / compare) * 100) : 0;
            return {
                variantId: variant.id,
                sale: symbol + formatPrice(price),
                regular: hasDiscount ? symbol + formatPrice(compare) : "",
                saved: hasDiscount ? "Save " + symbol + formatPrice(save) : "",
                percent: hasDiscount ? "(" + percent + "%)" : ""
            };
        }

        function getPriceScope(box) {
            const $scope = $(box).closest(".productView, .product, .product-section, main");
            return $scope.length && $scope.find(".price-item--sale").length ? $scope : $(document);
        }

        function setTextIfChanged($el, text) {
            if (!$el.length) return false;
            if ($el.text().trim() === text) return false;
            $el.text(text);
            return true;
        }

        // returns true when something was really changed in the DOM
        function writePrice(model, box) {
            const $root = getPriceScope(box);
            let changed = false;
            changed = setTextIfChanged($root.find(".price-item--sale").first(), model.sale) || changed;
            changed = setTextIfChanged($root.find(".price-item--regular").first(), model.regular) || changed;
            changed = setTextIfChanged($root.find(".price-item--saved").eq(0), model.saved) || changed;
            changed = setTextIfChanged($root.find(".price-item--saved").eq(1), model.percent) || changed;
            return changed;
        }

        var priceGuard = { observer: null, timer: null, model: null, box: null };
        function stopPriceGuard() {
            if (priceGuard.observer) {
                priceGuard.observer.disconnect();
                priceGuard.observer = null;
            }
            clearTimeout(priceGuard.timer);
        }
        function startPriceGuard(model, box) {
            stopPriceGuard();
            if (!window.MutationObserver) return;
            const $sale = getPriceScope(box).find(".price-item--sale").first();
            if (!$sale.length) return;

            const anchor = $sale.closest('[id^="price-"], .price, .productView-price')[0] || $sale[0];
            const watchRoot = anchor.parentElement || anchor;

            priceGuard.model = model;
            priceGuard.box = box;
            priceGuard.observer = new MutationObserver(function () {
                if (writePrice(priceGuard.model, priceGuard.box)) {
                    dlog("price restored after a theme update ->", priceGuard.model.sale);
                    if (priceGuard.observer) priceGuard.observer.takeRecords(); // ignore our own write
                }
            });
            priceGuard.observer.observe(watchRoot, { childList: true, subtree: true, characterData: true });
            priceGuard.timer = setTimeout(stopPriceGuard, 4000);
        }

        // Diagnostic only: the variant shown here must be the variant that gets
        // added to the cart (hidden <input name="id"> maintained by the theme).
        var verifyTimer;
        function verifyCartVariant(variantId) {
            clearTimeout(verifyTimer);
            verifyTimer = setTimeout(function () {
                const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
                if (input && input.value && String(input.value) !== String(variantId)) {
                    console.warn(
                        "[EliteDiam] Price shown is for variant " + variantId +
                        " but the theme will add variant " + input.value +
                        " to the cart. Theme variant matching (variants.js) needs a look."
                    );
                }
            }, 1200);
        }

        function updateVariantPrice(target) {
            if (
                !target ||
                !target.matches ||
                !target.matches('.product-form__radio, .ring-size-dropdown, .product-form__input input[type="radio"]')
            ) {
                return;
            }

            const box = document.querySelector(".productView-options") || document.querySelector(".product-form__input") && document.querySelector(".product-form__input").parentElement;
            if (!box) return;

            const variants = getVariantsJson();
            if (!variants || !variants.length) return;

            const selected = getSelectedOptionValues(box);

            let variant = variants.find(function (v) {
                return selected.every(function (val, i) {
                    return val === null || sameOption(v["option" + (i + 1)], val);
                });
            });
            const matchedByOptions = !!variant;

            if (!variant) {
                // fall back to the id the theme put in the URL
                const idFromUrl = new URL(window.location.href).searchParams.get("variant");
                variant = idFromUrl && variants.find(function (v) { return String(v.id) === String(idFromUrl); });
            }
            if (!variant) {
                console.warn("[EliteDiam] No variant matched selection:", selected);
                return;
            }

            // keep ?variant= in sync with the real selected variant
            try {
                const url = new URL(window.location.href);
                if (url.searchParams.get("variant") !== String(variant.id)) {
                    url.searchParams.set("variant", variant.id);
                    window.history.replaceState({}, "", url.toString());
                }
            } catch (e) { /* ignore */ }

            const model = buildPriceModel(variant);
            dlog("variant", variant.id, "selected", selected, "->", model.sale);
            writePrice(model, box);
            if (matchedByOptions) startPriceGuard(model, box);
            verifyCartVariant(variant.id);
        }

        document.addEventListener("change", function (e) {
            updateVariantPrice(e.target);
        });

        // ============================================
        // Initializations & Theme Section Events
        // ============================================
        onDomReady(function () {
            // Hero banner is above-the-fold — keep this fully immediate,
            // it must not be delayed (affects LCP / first paint content).
            initHeroBannerSlider();

            // PERF FIX: split into its own animation-frame tick so it isn't
            // glued to the hero slider's long task (TBT on mobile).
            requestAnimationFrame(function () {
                initRichTextReadMore();
            });

            // Reviews section: lazy-init read-more truncation + slider together
            // [IMPROVED] larger rootMargin: init starts well BEFORE the section is on
            // screen, so the user doesn't see the layout jump.
            whenVisible(".reviews-wrapper, .review-slider", function () {
                initReadMore();
                initReviewSlider();
            }, "900px 0px");

            // "Why Elite Diam" halo slider: lazy-init on its own
            whenVisible(".why-elite-diam", function () {
                initWhyEliteDiamSlider();
            });

            // [ADDED]
            initRingSizeDropdown();
            initSelectedColor();
            if (document.body.classList.contains("template-product")) {
                hideProductMeta();
                setTimeout(hideProductMeta, 500);
                setTimeout(hideProductMeta, 1500);
            }
        });

        document.addEventListener("shopify:section:load", function () {
            // Theme-editor section reloads need to reflect immediately,
            // so these stay eager (not lazy) here — same as original.
            initHeroBannerSlider();
            initReviewSlider();
            initWhyEliteDiamSlider();
            // [ADDED]
            initProductViewTabs($);
            initRingSizeDropdown();
            initFaqHandlers();
            initNewsletterPopup();
            initColorFilterState();
            hideProductMeta();
        });
        // Delegated generic WhatsApp Share
        document.addEventListener("click", function (e) {
            const shareBtn = e.target.closest(".whatsapp-share");
            if (!shareBtn) return;
            e.preventDefault();
            const title = shareBtn.getAttribute("data-product-title");
            const url = shareBtn.getAttribute("data-product-url");
            const message = encodeURIComponent(`${title} - ${url}`);
            window.open(`https://wa.me/?text=${message}`, "_blank", "noopener");
        });
        // Popup Dismissal (guarded, see initNewsletterPopup)
        onDomReady(initNewsletterPopup);
        // Accordion / FAQ Handlers  [now uses guarded function]
        onDomReady(function () {
            initFaqHandlers();
        });
        // WhatsApp CTA Handlers
        onDomReady(function () {
            const phone = "919023351659";

            function buildMessage(title, price, url, intro) {
                return `${intro}\n\n💎 ${title}\n💰 Price: ${price}\n🔗 ${url}\n\nCould you please guide me with more details and help me proceed?`;
            }

            function openWhatsApp(message) {
                window.open("https://wa.me/" + phone + "?text=" + encodeURIComponent(message), "_blank", "noopener");
            }
            document.addEventListener("click", function (e) {
                const detailBtn = e.target.closest(".whatsapp-btn-detail");
                if (detailBtn) {
                    e.preventDefault();
                    openWhatsApp(buildMessage(
                        detailBtn.getAttribute("data-product-title") || document.title,
                        detailBtn.getAttribute("data-price") || "",
                        detailBtn.getAttribute("data-product-url") || window.location.href,
                        "Hello, I'd like to buy this diamond:"
                    ));
                    return;
                }
                const cardBtn = e.target.closest(".whatsapp-btn-product-cart");
                if (cardBtn) {
                    e.preventDefault();
                    openWhatsApp(buildMessage(
                        cardBtn.getAttribute("data-product-title") || "",
                        cardBtn.getAttribute("data-price") || "",
                        cardBtn.getAttribute("data-product-url") || window.location.href,
                        "Hello, I'm interested in this diamond:"
                    ));
                    return;
                }
                const legacyBtn = e.target.closest("#whatsappBtn");
                if (legacyBtn) {
                    e.preventDefault();
                    openWhatsApp(buildMessage(
                        legacyBtn.getAttribute("data-product-title") || document.title,
                        legacyBtn.getAttribute("data-price") || "",
                        legacyBtn.getAttribute("data-product-url") || window.location.href,
                        "Hello, I am interested in buying this diamond:"
                    ));
                    return;
                }
            });
        });
        // ============================================
        // Facet Dash Filter Cleanup (kept jQuery-based, same as original)
        // ============================================
        function removeDashFilters() {
            $(".facets__item").each(function () {
                const value = $(this).find("input").val()?.trim();
                if (!value || value === "-") {
                    $(this).remove();
                }
            });
        }
        // Expose for the shared vanilla-JS observer below (outside this closure)
        window.__edRemoveDashFilters = removeDashFilters;

        $(document).ready(function () {
            removeDashFilters();
        });
    });
})();

// ============================================
// OPTIMIZED: Facet Dash Filter Cleanup + Carat Slider
//  - initCaratSlider stays a GLOBAL function.
//  - Runs independently of jQuery/Slick load status.
//  - Observer watches document.body, filtered + debounced.
//  - [ADDED] Multiple Carat blocks supported (querySelectorAll + toFixed(2))
// ============================================
function initCaratSlider() {
    // [ADDED] loop over ALL carat blocks (not only the first one)
    document.querySelectorAll(".sidebarBlock.Carat").forEach(function (block) {
        if (block.querySelector(".carat-range-slider")) return;
        const list = block.querySelector(".facets__list");
        if (!list) return;
        const items = [...list.querySelectorAll(".facets__item")];

        const values = items
            .map((el) => ({
                value: parseFloat(el.querySelector("input")?.value),
                input: el.querySelector("input"),
            }))
            .filter((v) => v.input && !isNaN(v.value))
            .sort((a, b) => a.value - b.value);
        if (!values.length) return;
        const min = values[0].value;
        const max = values[values.length - 1].value;
        const checked = values.filter((v) => v.input.checked);

        const currentMin = checked.length ? Math.min(...checked.map((v) => v.value)) : min;
        const currentMax = checked.length ? Math.max(...checked.map((v) => v.value)) : max;

        list.style.display = "none";
        const slider = document.createElement("div");
        slider.className = "carat-range-slider";
        slider.innerHTML = `
            <div class="range-wrap">
                <input 
                    type="range"
                    class="min"
                    min="${min}"
                    max="${max}"
                    step="0.01"
                    value="${currentMin}"
                >
                <input 
                    type="range"
                    class="max"
                    min="${min}"
                    max="${max}"
                    step="0.01"
                    value="${currentMax}"
                >
            </div>
            <div class="range-values">
                <span class="min-text">${currentMin.toFixed(2)} CT</span>
                <span class="max-text">${currentMax.toFixed(2)} CT</span>
            </div>
        `;
        list.before(slider);
        const wrap = slider.querySelector(".range-wrap");
        const minR = slider.querySelector(".min");
        const maxR = slider.querySelector(".max");
        const minT = slider.querySelector(".min-text");
        const maxT = slider.querySelector(".max-text");
        function updateSlider() {
            let a = parseFloat(minR.value);
            let b = parseFloat(maxR.value);
            if (a > b) {
                [a, b] = [b, a];

                minR.value = a;
                maxR.value = b;
            }
            const total = max - min;
            const start = total ? ((a - min) / total) * 100 : 0;
            const end = total ? ((b - min) / total) * 100 : 100;
            const width = end - start;
            wrap.style.setProperty("--range-start", `${start}%`);
            wrap.style.setProperty("--range-width", `${width}%`);
            minT.textContent = `${a.toFixed(2)} CT`;
            maxT.textContent = `${b.toFixed(2)} CT`;
        }
        function applyFilter() {
            let a = parseFloat(minR.value);
            let b = parseFloat(maxR.value);
            if (a > b) {
                [a, b] = [b, a];
            }
            values.forEach((v) => {
                v.input.checked = v.value >= a && v.value <= b;
            });
            let target = values.find((v) => v.input.checked);
            if (!target) {
                // [v2 FIX] the chosen range fell between two available carats:
                // before, nothing was selected and no filter request was sent.
                // Snap to the nearest available carat so the list still updates.
                const mid = (a + b) / 2;
                target = values.reduce((best, v) =>
                    Math.abs(v.value - mid) < Math.abs(best.value - mid) ? v : best, values[0]);
                target.input.checked = true;
                minR.value = target.value;
                maxR.value = target.value;
            }
            target.input.dispatchEvent(
                new Event("change", {
                    bubbles: true,
                })
            );
            updateSlider();
        }
        minR.addEventListener("input", updateSlider);
        maxR.addEventListener("input", updateSlider);
        minR.addEventListener("change", applyFilter);
        maxR.addEventListener("change", applyFilter);
        updateSlider();
    });
}
(function () {
    "use strict";
    var isMutating = false; // true while we are making our own DOM edits below
    var pendingWork = false;
    var debounceTimer = null;

    // Only mutations touching these trigger a rescan.
    // [ADDED] .product-form__input so the ring-size dropdown is rebuilt
    // if the product options get re-rendered.
    var RELEVANT_SELECTOR = ".facets__item, .facets__list, .sidebarBlock.Carat, .carat-range-slider, .product-form__input, .diamond-faq, .faq-question, #newsletter-success-modal";

    function nodeIsRelevant(node) {
        if (!node || node.nodeType !== 1) return false; // element nodes only
        if (typeof node.matches === "function" && node.matches(RELEVANT_SELECTOR)) return true;
        if (typeof node.closest === "function" && node.closest(RELEVANT_SELECTOR)) return true;
        if (typeof node.querySelector === "function" && node.querySelector(RELEVANT_SELECTOR)) return true;
        return false;
    }

    function mutationsAreRelevant(mutationsList) {
        for (var i = 0; i < mutationsList.length; i++) {
            var m = mutationsList[i];
            if (m.type !== "childList") continue;

            for (var a = 0; a < m.addedNodes.length; a++) {
                if (nodeIsRelevant(m.addedNodes[a])) return true;
            }
            for (var r = 0; r < m.removedNodes.length; r++) {
                if (nodeIsRelevant(m.removedNodes[r])) return true;
            }
            // [v2 PERF] target: only "is it INSIDE a relevant node" (cheap closest).
            // The old deep querySelector on big containers (body, main ...) made almost
            // every DOM change on a product page look relevant.
            var t = m.target;
            if (t && t.nodeType === 1 && typeof t.closest === "function" && t.closest(RELEVANT_SELECTOR)) return true;
        }
        return false;
    }

    function safeRemoveDashFilters() {
        if (typeof window.__edRemoveDashFilters === "function") {
            window.__edRemoveDashFilters();
        } else {
            document.querySelectorAll(".facets__item").forEach(function (item) {
                var input = item.querySelector("input");
                var value = input && input.value ? input.value.trim() : "";
                if (!value || value === "-") {
                    item.remove();
                }
            });
        }
    }
    function safeCall(name) {
        if (typeof window[name] === "function") window[name]();
    }
    function safeInitRingSize() {
        // [ADDED] available only after jQuery closure has loaded
        if (typeof window.__edInitRingSize === "function") {
            window.__edInitRingSize();
        }
    }
    function runScheduledWork() {
        isMutating = true; // ignore mutations caused by our own edits below
        safeRemoveDashFilters();
        initCaratSlider();
        safeInitRingSize(); // [ADDED]
        safeCall("__edInitFaq");
        safeCall("__edInitNewsletterPopup");
        safeCall("__edInitColorFilterState");
        requestAnimationFrame(function () {
            isMutating = false;
        });
    }
    function scheduleWork() {
        if (isMutating) return;
        pendingWork = true;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
            if (!pendingWork) return;
            pendingWork = false;
            runScheduledWork();
        }, 200);
    }
    var sharedObserver = new MutationObserver(function (mutationsList) {
        if (isMutating) return;
        if (!mutationsAreRelevant(mutationsList)) return;
        scheduleWork();
    });
    function startObserving() {
        sharedObserver.observe(document.body, { childList: true, subtree: true });
    }
    function init() {
        safeRemoveDashFilters();
        initCaratSlider();
        startObserving();
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
    document.addEventListener("shopify:section:load", function () {
        safeRemoveDashFilters();
        initCaratSlider();
    });
})();

// ============================================================
// [ADDED] Diamond Size Header Update (vanilla, independent of jQuery)
// ============================================================
(function () {
    function updateDiamondSizeHeader() {
        const fieldsets = document.querySelectorAll('fieldset[data-product-attribute="set-rectangle"]');
        fieldsets.forEach(function (fieldset) {
            const radio = fieldset.querySelector('input[name="Select Diamond Size:"]:checked');
            const header = fieldset.querySelector('legend span[data-header-option]');
            if (!radio || !header) return;
            header.textContent = radio.value;
        });
    }

    // Radio change
    document.addEventListener("change", function (e) {
        if (e.target.matches('input.product-form__radio[name="Select Diamond Size:"]')) {
            updateDiamondSizeHeader();
        }
    });

    // Label click fallback
    document.addEventListener("click", function (e) {
        const label = e.target.closest("label.product-form__label[data-variant-id]");
        if (!label) return;
        const radioId = label.getAttribute("for");
        if (!radioId) return;
        const radio = document.getElementById(radioId);
        if (!radio) return;
        // [v2 FIX] never force-check an unavailable (disabled) size - that showed a
        // size in the header that was not really selected
        if (radio.disabled) return;
        setTimeout(function () {
            radio.checked = true;
            updateDiamondSizeHeader();
        }, 50);
    });

    // Initial selected value (works even if DOM is already parsed)
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", updateDiamondSizeHeader);
    } else {
        updateDiamondSizeHeader();
    }

    // Shopify dynamic section support
    document.addEventListener("shopify:section:load", updateDiamondSizeHeader);
})();

// ============================================================
// [ADDED] Thumbnail click -> replace main image
// ============================================================
(function () {
    function bindThumbnailClick() {
        document.addEventListener("click", function (e) {
            const thumb = e.target.closest(".productView-thumbnail-link");
            if (!thumb) return;
            const thumbnail = thumb.closest(".productView-thumbnail");
            document.querySelectorAll(".productView-thumbnail").forEach(function (item) {
                item.classList.remove("active");
            });
            if (thumbnail) {
                thumbnail.classList.add("active");
            }
            // [FIX] If Slick gallery is active it already switches the main image
            // (asNavFor). Overwriting slide #1 here would show the wrong image.
            if (document.querySelector(".productView-nav.slick-initialized")) return;
            const thumbImg = thumb.querySelector("img");
            if (!thumbImg) return;
            let imageUrl =
                thumb.getAttribute("data-image") ||
                thumb.getAttribute("href") ||
                thumbImg.getAttribute("data-src") ||
                thumbImg.getAttribute("src");
            if (!imageUrl) return;
            if (imageUrl.startsWith("//")) {
                imageUrl = "https:" + imageUrl;
            }
            imageUrl = imageUrl.replace(
                /_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*|\d+x)(?=\.[a-zA-Z]+(?:\?|$))/,
                ""
            );
            // Find main image
            const mainImage =
                document.querySelector(".productView-image-wrapper img") ||
                document.querySelector(".productView-image img");
            if (!mainImage) return;
            const image = new Image();
            image.onload = function () {
                mainImage.src = imageUrl;
                // Clear responsive image sources
                mainImage.removeAttribute("srcset");
                mainImage.removeAttribute("sizes");
                // Update common lazy-load attributes
                mainImage.setAttribute("data-src", imageUrl);
                mainImage.setAttribute("data-original", imageUrl);
                // Remove blur/lazy classes if present
                mainImage.classList.remove("lazyload");
                mainImage.classList.remove("lazyloading");
                mainImage.classList.remove("blur-up");
            };
            image.src = imageUrl;
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bindThumbnailClick);
    } else {
        bindThumbnailClick();
    }
})();